{
  "name": "materio-vuetify-vuejs-admin-template",
  "version": "1.0.798",
  "private": true,
  "type": "module",
  "scripts": {
    "dev": "vite --host",
    "build": "vite build",
    "preview": "vite preview",
    "typecheck": "vue-tsc --noEmit",
    "test:realtime": "node --import tsx --test tests/realtime.test.ts",
    "lint": "eslint . -c .eslintrc.cjs --fix --ext .ts,.js,.cjs,.vue,.tsx,.jsx",
    "build:icons": "tsx src/plugins/iconify/build-icons.ts",
    "msw:init": "msw init public/ --save",
    "postinstall": "npm run build:icons && npm run msw:init",
    "prepare": "husky"
  },
  "dependencies": {
    "@casl/ability": "6.7.2",
    "@casl/vue": "2.2.2",
    "@floating-ui/dom": "1.6.8",
    "@formkit/drag-and-drop": "0.1.6",
    "@iconify-json/bxl": "1.2.2",
    "@logto/browser": "3.0.13",
    "@logto/client": "3.1.8",
    "@logto/vue": "3.0.13",
    "@sindresorhus/is": "7.0.1",
    "@tiptap/extension-blockquote": "^2.27.2",
    "@tiptap/extension-color": "^2.27.2",
    "@tiptap/extension-highlight": "^2.10.4",
    "@tiptap/extension-image": "^2.10.4",
    "@tiptap/extension-link": "^2.10.4",
    "@tiptap/extension-table": "^2.27.2",
    "@tiptap/extension-table-cell": "^2.27.2",
    "@tiptap/extension-table-header": "^2.27.2",
    "@tiptap/extension-table-row": "^2.27.2",
    "@tiptap/extension-text-align": "^2.10.4",
    "@tiptap/extension-text-style": "^2.27.2",
    "@tiptap/pm": "^2.10.4",
    "@tiptap/starter-kit": "^2.10.4",
    "@tiptap/vue-3": "^2.10.4",
    "@vueuse/core": "^14.3.0",
    "@vueuse/math": "^14.3.0",
    "apexcharts": "^5.16.0",
    "axios": "^1.18.1",
    "centrifuge": "^5.7.0",
    "chart.js": "4.4.7",
    "cookie-es": "1.2.2",
    "cropperjs": "^1.6.2",
    "destr": "2.0.3",
    "eslint-plugin-regexp": "2.7.0",
    "isomorphic-dompurify": "^3.14.0",
    "jwt-decode": "4.0.0",
    "lodash-es": "^4.17.21",
    "mapbox-gl": "^3.27.0",
    "markdown-it": "^14.2.0",
    "matrix-js-sdk": "^41.8.0-rc.0",
    "opus-recorder": "^8.0.5",
    "photoswipe": "^5.4.4",
    "pinia": "^4.0.2",
    "prismjs": "1.29.0",
    "quill": "^2.0.3",
    "roboto-fontface": "0.10.0",
    "shepherd.js": "13.0.3",
    "swiper": "^11.2.10",
    "ufo": "1.5.4",
    "unplugin-vue-define-options": "1.5.3",
    "uuid": "^13.0.0",
    "vue": "^3.5.40",
    "vue-chartjs": "5.3.2",
    "vue-draggable-next": "^2.3.0",
    "vue-flatpickr-component": "11.0.5",
    "vue-i18n": "10.0.4",
    "vue-logger-plugin": "^2.2.3",
    "vue-prism-component": "2.0.0",
    "vue-router": "^4.6.4",
    "vue3-apexcharts": "1.8.0",
    "vue3-emoji-picker": "^1.1.8",
    "vue3-perfect-scrollbar": "2.0.0",
    "vuetify": "^3.12.11",
    "webfontloader": "1.6.28",
    "zod": "^4.1.8"
  },
  "devDependencies": {
    "@antfu/eslint-config-vue": "0.43.1",
    "@antfu/utils": "0.7.10",
    "@fullcalendar/core": "^6.1.21",
    "@fullcalendar/daygrid": "^6.1.21",
    "@fullcalendar/interaction": "^6.1.21",
    "@fullcalendar/list": "^6.1.21",
    "@fullcalendar/multimonth": "^6.1.21",
    "@fullcalendar/resource": "^6.1.21",
    "@fullcalendar/resource-timeline": "^6.1.21",
    "@fullcalendar/timegrid": "^6.1.21",
    "@fullcalendar/vue3": "^6.1.21",
    "@iconify-json/mdi": "1.2.2",
    "@iconify-json/ri": "1.2.5",
    "@iconify/tools": "4.1.1",
    "@iconify/utils": "2.2.1",
    "@iconify/vue": "4.1.2",
    "@intlify/unplugin-vue-i18n": "5.3.1",
    "@stylistic/stylelint-config": "1.0.1",
    "@stylistic/stylelint-plugin": "2.1.3",
    "@tiptap/extension-character-count": "^2.10.4",
    "@tiptap/extension-placeholder": "^2.10.4",
    "@tiptap/extension-subscript": "^2.10.4",
    "@tiptap/extension-superscript": "^2.10.4",
    "@tiptap/extension-underline": "^2.10.4",
    "@types/mapbox-gl": "3.4.1",
    "@types/markdown-it": "^14.1.2",
    "@types/node": "^22.20.1",
    "@types/webfontloader": "1.6.38",
    "@typescript-eslint/eslint-plugin": "7.18.0",
    "@typescript-eslint/parser": "7.18.0",
    "@videojs-player/vue": "1.0.0",
    "@vitejs/plugin-vue": "^6.0.8",
    "@vitejs/plugin-vue-jsx": "^5.1.6",
    "eslint": "8.57.1",
    "eslint-config-airbnb-base": "15.0.0",
    "eslint-import-resolver-typescript": "3.7.0",
    "eslint-plugin-case-police": "0.6.1",
    "eslint-plugin-import": "2.31.0",
    "eslint-plugin-promise": "6.6.0",
    "eslint-plugin-regex": "1.10.0",
    "eslint-plugin-sonarjs": "0.24.0",
    "eslint-plugin-unicorn": "51.0.1",
    "eslint-plugin-vue": "9.32.0",
    "husky": "^9.1.7",
    "msw": "^2.15.0",
    "postcss-html": "1.7.0",
    "postcss-scss": "4.0.9",
    "sass": "^1.101.7",
    "sharp": "^0.35.3",
    "shiki": "1.24.4",
    "stylelint": "16.8.0",
    "stylelint-config-idiomatic-order": "10.0.0",
    "stylelint-config-standard-scss": "13.1.0",
    "stylelint-use-logical-spec": "5.0.1",
    "tsx": "4.19.2",
    "type-fest": "4.30.2",
    "typescript": "5.7.2",
    "unplugin-auto-import": "0.18.6",
    "unplugin-vue-components": "0.27.5",
    "unplugin-vue-router": "0.8.8",
    "video.js": "^7.21.7",
    "vite": "^8.1.5",
    "vite-plugin-mkcert": "^2.0.0",
    "vite-plugin-pwa": "^1.3.0",
    "vite-plugin-vue-devtools": "^8.1.5",
    "vite-plugin-vue-layouts": "0.11.0",
    "vite-plugin-vuetify": "^2.1.3",
    "vite-svg-loader": "5.1.0",
    "vue-shepherd": "3.0.0",
    "vue-tsc": "^2.1.6"
  },
  "resolutions": {
    "postcss": "^8",
    "@tiptap/core": "^2",
    "@types/video.js": "^7"
  },
  "overrides": {
    "postcss": "^8",
    "@tiptap/core": "^2",
    "@types/video.js": "^7"
  },
  "msw": {
    "workerDirectory": "public"
  }
}
